type CurrencyCode = 'ZAR'

export type CurrencyProps = {
  code?: CurrencyCode
  value?: string | number
}

function parse(value) {
  if (typeof value === 'string') {
    return Number(value)
  }

  return value
}

function format(code: CurrencyCode, value: number) {
  if (code !== 'ZAR') {
    throw new Error('Currency only support ZAR')
  }

  return value.toLocaleString('en-GB', { style: 'currency', currency: 'ZAR' })
}

export function Currency({ code = 'ZAR', value }: CurrencyProps) {
  if (!value) {
    return <>{format(code, 0)}</>
  }

  const parsed = parse(value)

  return <>{format(code, parsed)}</>
}
